import useDispensary from 'src/dispensary/hooks/use-dispensary';
import { MenuFilterChipsSettings } from 'src/gql/graphql';

type SpecialsPageSettings = {
  menuFilterChips: MenuFilterChipsSettings | null;
  showCategoryTiles: boolean | null;
  showSpecialDuration: boolean | null;
};

// Read from the already-resolved dispensary (storeSettings ships on baseDispensaryFragment), so
// there's no second query and no id-matching against a search-style result to get wrong.
export function useSpecialsPageSettings(): SpecialsPageSettings {
  const { dispensary } = useDispensary();
  const settings = dispensary?.storeSettings?.specialsPage;

  return {
    menuFilterChips: settings?.menuFilterChips ?? null,
    showCategoryTiles: settings?.showCategoryTiles ?? null,
    showSpecialDuration: settings?.showSpecialDuration ?? null,
  };
}
